module.exports = __webpack_public_path__ + "career-icon-401k.3-lYivnI.svg";